
import { useState } from "react";

import * as C from "./styles";
import { CgSpinner } from "react-icons/cg";

export function Btn({
  backgroundColor,
  width,
  height,
  hoverColor,
  color,
  click,
  icon,
  leftIcon,
  text,
  fontSize,
  border,
  borderRadius,
  disabled,
  isLoginButton,
  isShadow = true,
  spinnerSize = 20,
  fontWeight = 600,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (!click) return;

    if(disabled) return

    const result = click();

    if (result instanceof Promise) {
      try {
        setIsLoading(true);
        await result;
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <C.CustomButton
      $backgroundColor={backgroundColor}
      $width={width}
      $containsIcon={!!icon}
      $height={height}
      $hoverColor={hoverColor}
      $color={color}
      $disabled={isLoading || disabled}
      $fontSize={fontSize}
      $isLoginButton={isLoginButton}
      $border={border}
      $borderRadius={borderRadius}
      $isShadow={isShadow}
      $fontWeight={fontWeight}
      onClick={handleClick}
    >
      {(!isLoading && leftIcon && icon) && icon}

      {isLoading &&
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', backgroundColor: isLoading ? "rgba(0, 0, 0, 0.212)" : "transparent", borderRadius: borderRadius ? borderRadius : '8px' }}>
          <CgSpinner size={spinnerSize} className="spinner" color="white" />
        </div>
      }

      {text && text}

      {(!isLoading && !leftIcon && icon) && icon}
    </C.CustomButton>
  );
}
